import { render, staticRenderFns } from "./SelectCaja.vue?vue&type=template&id=6ae989c7&"
import script from "./SelectCaja.vue?vue&type=script&lang=js&"
export * from "./SelectCaja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports